var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import styled, { css } from "styled-components";
export var Marker = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  z-index: ", ";\n  position: absolute;\n  display: flex;\n  opacity: 0;\n  left: 0;\n  top: 0;\n\n  ", "\n"], ["\n  z-index: ", ";\n  position: absolute;\n  display: flex;\n  opacity: 0;\n  left: 0;\n  top: 0;\n\n  ", "\n"])), function (_a) {
  var zIndex = _a.zIndex;
  return zIndex;
}, function (_a) {
  var debug = _a.debug;
  return debug && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      width: 1px;\n      height: 1px;\n      background-color: #00ff37;\n      z-index: 100;\n    "], ["\n      width: 1px;\n      height: 1px;\n      background-color: #00ff37;\n      z-index: 100;\n    "])));
});
export var Popup = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 12;\n"], ["\n  display: flex;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 12;\n"])));
var templateObject_1, templateObject_2, templateObject_3;